import { TrendlineAlgorithm } from '@/interfaces/reporting/trendline';
import { titleize } from '@/utils/strings';
import { isDashedBorder } from '../common/Border/utils';
import Button from '@/components/Button';
import { Label, Input, Select } from '@/components/FormElements';
import BorderFields, { BorderStyle } from '@/components/Editor/Form/fields/common/Border';
import RevealPill, { PillSwitch } from '@/components/Editor/Form/fields/RevealPill';
import ColorPicker from '@/components/Editor/Form/fields/common/ColorPicker';
import Tension from '@/components/Editor/Form/fields/common/Tension';
import { DEFAULTS as trendlineDefaults } from '@/components/widget/utils/trendlines';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const EditorFieldsTrendline = _ref => {
  let {
    nameSpace,
    isCreated,
    display,
    description,
    algorithm,
    label,
    borderWidth,
    borderDash,
    borderColor,
    backgroundColor,
    tension,
    textOverrides = {},
    openButtonVariant,
    hasLegend = true,
    onChange,
    onDelete
  } = _ref;
  const algorithmId = `${nameSpace}-trendline-algorithm`;
  const legendLabelId = `${nameSpace}-trendline-legend-label`;
  return /*#__PURE__*/_jsxs(RevealPill, {
    label: "Trendline",
    disableOpen: !display,
    openButtonVariant: openButtonVariant,
    activeState: /*#__PURE__*/_jsx(PillSwitch, {
      checked: display,
      onChange: checked => onChange({
        display: checked
      })
    }),
    children: [/*#__PURE__*/_jsx("header", {
      className: "-mb-small",
      children: /*#__PURE__*/_jsx("small", {
        children: description
      })
    }), /*#__PURE__*/_jsx(Label, {
      forInput: algorithmId,
      className: parentStyles.formField,
      text: "Algorithm",
      caption: "How to draw the relationship between data points.",
      children: /*#__PURE__*/_jsx(Select, {
        id: algorithmId,
        defaultValue: algorithm || TrendlineAlgorithm.Linear,
        onChange: evt => {
          // @ts-ignore
          const value = evt.target.value;
          onChange({
            algorithm: value === TrendlineAlgorithm.Linear ? null : value
          });
        },
        children: Object.values(TrendlineAlgorithm).map(algo => /*#__PURE__*/_jsx("option", {
          value: algo,
          children: titleize(algo)
        }, `${nameSpace}-${algo}`))
      })
    }), /*#__PURE__*/_jsx(BorderFields, {
      nameSpace: nameSpace,
      width: borderWidth,
      style: isDashedBorder(borderDash) ? BorderStyle.Dashed : undefined,
      color: borderColor || '',
      defaults: {
        width: trendlineDefaults.borderWidth,
        color: trendlineDefaults.borderColor,
        style: BorderStyle.Solid
      },
      textOverrides: {
        legend: textOverrides.borderFieldsLegend,
        clearBorder: textOverrides.clearBorder,
        colorPickerLabel: textOverrides.colorPickerLabel
      },
      enabledButtonStyles: [BorderStyle.Solid, BorderStyle.Dashed],
      onChangeColor: borderColor => onChange({
        borderColor
      }),
      onChangeStyle: borderStyle => onChange({
        borderDash: borderStyle === BorderStyle.Dashed ? [5, 5] : [0, 0]
      }),
      onChangeWidth: borderWidth => onChange({
        borderWidth
      }),
      onDelete: () => onChange({
        borderColor: null,
        borderDash: [0, 0],
        borderWidth: null,
        display: false
      })
    }), /*#__PURE__*/_jsx(ColorPicker, {
      label: "Background Color",
      caption: "Optional fill color for the trendline",
      defaultValue: backgroundColor,
      onChange: color => onChange({
        fill: typeof color === 'string' ? true : null,
        backgroundColor: typeof color === 'string' ? color : null
      })
    }), /*#__PURE__*/_jsx(Tension, {
      nameSpace: nameSpace,
      tension: tension,
      onChange: onChange
    }), hasLegend ? /*#__PURE__*/_jsx(Label, {
      forInput: legendLabelId,
      text: "Legend Label",
      className: parentStyles.formField,
      caption: "Empty labels will be removed from the legend",
      children: /*#__PURE__*/_jsx(Input, {
        id: legendLabelId,
        placeholder: "Average",
        defaultValue: label,
        onChange: evt => onChange({
          label: `${evt.target.value || ''}`.trim() || null
        })
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {}), isCreated ? /*#__PURE__*/_jsx(Button, {
      variant: "delete",
      size: "small",
      onClick: onDelete,
      children: "Destroy Trendline"
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};

export default EditorFieldsTrendline;